import { BaseAction } from "../../../core/actions/BaseAction";
import { updateRecoilState } from "../../../Orchestrator/Recoils/Events/Recoil";
import { ICookiePreferences } from "../../../Orchestrator/Types/Interface/ICookiePreferences";
import {
  hasCookieConsent,
  isFirstTimeVisitor,
  getCookiePreferences,
  getDefaultPreferences
} from "../../../Lib/Utils/CookieConsentUtils";

export class InitializeCookieConsentAction extends BaseAction<void, void> {
  override async run(): Promise<void> {
    try {
      const hasConsent = hasCookieConsent();
      const isFirstTime = isFirstTimeVisitor();

      if (hasConsent) {
        // User has already given consent, load their preferences
        const savedPreferences = getCookiePreferences();
        updateRecoilState('cookieConsentGivenAtom', true);
        updateRecoilState('cookiePreferencesAtom', savedPreferences);
        updateRecoilState('cookieConsentBannerVisibleAtom', false);
      } else if (isFirstTime) {
        // First time visitor, show banner
        updateRecoilState('cookieConsentGivenAtom', false);
        updateRecoilState('cookieConsentBannerVisibleAtom', true);
        updateRecoilState('cookiePreferencesAtom', getDefaultPreferences());
      }
    } catch (error) {
      console.error("Error in InitializeCookieConsentAction:", error);
    }
  }
} 